import { render, staticRenderFns } from "./AddClient.vue?vue&type=template&id=05fe740e&scoped=true&"
import script from "./AddClient.vue?vue&type=script&lang=js&"
export * from "./AddClient.vue?vue&type=script&lang=js&"
import style0 from "./AddClient.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddClient.vue?vue&type=style&index=1&id=05fe740e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe740e",
  null
  
)

export default component.exports